export type TabKey = 'mac' | 'windows';

export interface PlatformOption {
  value: string;
  label: string;
}

export const PLATFORM_OPTIONS: Record<TabKey, PlatformOption[]> = {
  mac: [
    { value: 'mac-apple-silicon', label: 'Mac with Apple silicon' },
    { value: 'mac-intel', label: 'Mac with Intel processor' },
  ],
  windows: [
    { value: 'windows-x64', label: 'Windows (Intel/AMD)' },
    { value: 'windows-arm', label: 'Windows (ARM)' },
  ],
};

export const DESKTOP_DOWNLOAD_URLS: Record<string, string> = {
  'mac-apple-silicon':
    'https://sfc-repo.snowflakecomputing.com/coco-desktop/downloads/latest/Cortex-Code-darwin-arm64.dmg',
  'mac-intel':
    'https://sfc-repo.snowflakecomputing.com/coco-desktop/downloads/latest/Cortex-Code-darwin-x64.dmg',
  'windows-x64':
    'https://sfc-repo.snowflakecomputing.com/coco-desktop/downloads/latest/Cortex-Code-win32-x64-user-setup.exe',
  'windows-arm':
    'https://sfc-repo.snowflakecomputing.com/coco-desktop/downloads/latest/Cortex-Code-win32-arm64-user-setup.exe',
};

export const CLI_COMMAND: Record<TabKey, string> = {
  mac: 'curl -LsS https://ai.snowflake.com/static/cc-scripts/install.sh | sh',
  windows: 'irm https://ai.snowflake.com/static/cc-scripts/install.ps1 | iex',
};

export const CLI_SUBTITLE: Record<TabKey, string> = {
  mac: 'MacOS / Linux / Windows (WSL)',
  windows: 'Windows (Native)',
};
